// extracted by mini-css-extract-plugin
export var cardHeader = "_i2-1";
export var contentCard = "_i2-0";
export var headerActions = "_i2-3";
export var reorderHandle = "_i2-5";
export var titleArea = "_i2-2";
export var titleAreaWithHandle = "_i2-4";